(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-custom"] && !Shopify.designMode) return;
  try {
    
  class HeaderCustom extends HTMLElement {
    connectedCallback() {
      this.transparentEnabled = this.dataset.transparent === 'true';
      this.burger = this.querySelector('[data-mobile-toggle]');
      this.nav = this.querySelector('[data-mobile-nav]');
      this.searchToggle = this.querySelector('[data-search-toggle]');
      this.searchBar = this.querySelector('[data-search-bar]');
      this.spacer = this.nextElementSibling;

      this.updateSpacer = this.updateSpacer.bind(this);
      this.updateSpacer();
      window.addEventListener('resize', this.updateSpacer);
      window.addEventListener('load', this.updateSpacer);

      if (this.transparentEnabled) {
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      this.burger?.addEventListener('click', () => this.toggleMobileNav());
      this.searchToggle?.addEventListener('click', () => this.toggleSearch());

      this.querySelectorAll('.header-custom__menu-item.has-dropdown > .header-custom__menu-link').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (window.matchMedia('(max-width: 989px)').matches) {
            event.preventDefault();
            const item = link.closest('.header-custom__menu-item');
            const isOpen = item.classList.contains('is-open');
            this.querySelectorAll('.header-custom__menu-item.is-open').forEach((el) => el.classList.remove('is-open'));
            if (!isOpen) item.classList.add('is-open');
          }
        });
      });
    }

    updateSpacer() {
      if (!this.spacer || !this.spacer.classList.contains('header-custom__spacer')) return;

      this.spacer.style.height = this.offsetHeight + 'px';
    }

    onScroll() {
      const scrolled = window.scrollY > 40;
      this.classList.toggle('is-scrolled', scrolled);
    }

    toggleMobileNav() {
      const isOpen = this.nav.classList.toggle('is-open');
      this.burger.setAttribute('aria-expanded', isOpen);
    }

    toggleSearch() {
      const isOpen = this.searchBar.classList.toggle('is-open');
      this.searchBar.hidden = false;
      this.searchToggle.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        this.searchBar.querySelector('input')?.focus();
      }
    }
  }

  customElements.define('header-custom', HeaderCustom);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
